// HintButton.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function HintButton() {
  const [showHint, setShowHint] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    try {
      // モーダルを表示（fallbackを備える）
      setShowHint(true);
    } catch (e) {
      window.location.href = '/hint.html'; // フォールバック
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          // ▼▼▼ 修正: 固定位置の指定を削除しました ▼▼▼
          // position: 'fixed',
          // top: '12px',
          // right: '12px',
          // ▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲▲
          
          zIndex: 999,
          backgroundColor: '#330000',
          color: 'white',
          border: 'none',
          borderRadius: '9999px',
          width: '24px',  // サイズを明示的に指定して正円にしやすくする
          height: '24px', // サイズを明示的に指定
          display: 'flex',            // 中身を中央揃えにする
          alignItems: 'center',       // 〃
          justifyContent: 'center',   // 〃
          fontSize: '14px',
          fontWeight: 'bold',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          cursor: 'pointer',
          padding: 0 // パディングがあるとサイズがズレることがあるので0に
        }}
      >
        ❓
      </button>

      {showHint && (
        <div
          onClick={() => setShowHint(false)}
          style={{
            position: 'fixed',
            top: 0, left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 9999 // モーダルは一番手前に
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: '20%',
              left: '50%',
              transform: 'translate(-50%, -20%)',
              backgroundColor: 'white',
              padding: '24px',
              borderRadius: '12px',
              width: '80vw',
              maxWidth: '480px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              textAlign: 'center',
              zIndex: 10000
            }}
          >
            <h2 style={{ marginBottom: '12px' }}>💡{t('hint_title')}</h2>
            <p style={{ fontSize: '16px', lineHeight: '1.5' }}>
              {t('hint')}
            </p>
            <button
              onClick={() => setShowHint(false)}
              style={{
                marginTop: '16px',
                padding: '8px 16px',
                fontSize: '14px',
                backgroundColor: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {t('close')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}